import React, { Component }            from 'react';
import { Alert, Card, Modal, Button }  from 'react-bootstrap';
import { LocalForm }                   from 'react-redux-form';
import { ClipLoader }                  from 'react-spinners';
import { withRouter }                  from 'react-router';
import { connect }                     from 'react-redux';
import PubSub                          from 'pubsub-js';
import { MdDelete }                    from 'react-icons/md';
import { MdAddCircle }                 from 'react-icons/md';
import { MdLibraryAdd }                from 'react-icons/md';
import { isLoggedIn,
         isInRoleFromToken }           from '../../../../utils/authService';
import { EmployeeOnboardingConstants } from '../environment';
import { responsesFetchData,
         responsesAddFetchData,
         responsesDeleteFetchData }    from '../../../../actions/employee-onboarding/responses';

var apiHost = EmployeeOnboardingConstants.WebApiHost;

class Responses extends Component {
    
  constructor(props) {
    super(props);
    this.state = { 
      description      : '',
      descriptionValid : true,
      showModal        : false
    };

    this.handleSubmit      = this.handleSubmit.bind(this);
    this.updateDescription = this.updateDescription.bind(this);
    this.reload            = this.reload.bind(this);
    this.close             = this.close.bind(this);
    this.open              = this.open.bind(this);
    this.delete            = this.delete.bind(this);
  }
  
  subscriber(msg, data){
    this.reload();
  }

  close() {
    this.setState({ showModal: false });
  }

  open() {
    this.setState({ showModal: true });
  }

  delete(event) {
    var id = event.currentTarget.id;
    var params = {
      id: id
    };
    
    this.props.fetchDataResponsesDelete(apiHost, params);
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.state.description) {
      var params = {
        description: this.state.description
      };

      this.props.fetchDataResponsesAdd(apiHost, params);
    }
  }

  updateDescription(event) {
    if (event.target.value) {
      this.setState({ description: event.target.value, descriptionValid: true });
    }
    else {
      this.setState({ description: '', descriptionValid: false });
    }
  }

  reload() {
    this.setState({description: '', showModal: false}, function() {
      this.props.fetchDataResponses(apiHost);
    });
  }
  
  componentDidMount() {
    this.reload();
    this.token = PubSub.subscribe('employee.responses.reload', this.subscriber.bind(this));
  }
  
  componentWillUnmount(){
    PubSub.unsubscribe(this.token);
  }

  render() {
    let add = 
      <div>
        <div style={{marginBottom: '10px', marginLeft: '10px'}}>
          <button onClick={this.open}>   
            <MdAddCircle size={24} />
          </button>
        </div>
        <Modal animation={false} show={this.state.showModal} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>Add Canned Response</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{marginBottom: '10px'}}>
              <LocalForm onSubmit={(values) => this.handleSubmit(values)}>
                <div style={{marginLeft: '10px'}} className='block'>
                  <label>
                    Description &nbsp;
                  </label>
                  <textarea rows='4' cols='50' style={{float: 'initial', marginBottom: '10px'}} value={this.state.description} className={this.state.descriptionValid ? '' : 'invalid'} name='description' onChange={evt => this.updateDescription(evt)} />
                  </div>
                  <button title='Add' style={{marginLeft: '10px'}} onClick={this.handleSubmit}>
                    <MdLibraryAdd size={32} />
                  </button>
              </LocalForm>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>;

    let content = null;
    if (this.props.responses.Items && isLoggedIn() && isInRoleFromToken(EmployeeOnboardingConstants.AdminRole)) {
      if (!this.props.responsesIsLoading && this.props.responses.Items.length === 0) {
        content =
          <div>
            {add}
            <Alert bsStyle="warning">
              <strong>No Canned Responses</strong>
            </Alert>
          </div>;
      }
      else if (!this.props.responsesIsLoading) {
        var list = [];
        for (var i = 0; i < this.props.responses.Items.length; i++) {
          var item    = this.props.responses.Items[i];
          list.push(
            <Card key={i}>
              <Card.Body>
                {item.Description}
                <div style={{float: 'right'}}>
                  <button id={item.Id} onClick={this.delete}>
                    <MdDelete size={24} />
                  </button> 
                </div>
              </Card.Body>
            </Card>
          );
        }

        content =
          <div>
            {add}
            {list}
          </div>;
      } 
    }

    return (
      <div>
        <div style={{ marginRight: 'auto', marginLeft: 'auto', width: '5em' }}>
          { this.props.responsesIsLoading && isLoggedIn() && isInRoleFromToken(EmployeeOnboardingConstants.AdminRole) ?
            <ClipLoader
              color={'#072659'} 
              loading={this.props.responsesIsLoading} 
            />
            : <span />
          }
        </div>
        {content}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    responses: state.employee.responses.responses,
    responsesHasErrored: state.employee.responses.responsesHasErrored,
    responsesIsLoading: state.employee.responses.responsesIsLoading,
    responsesAdd: state.employee.responses.responsesAdd,
    responsesAddHasErrored: state.employee.responses.responsesAddHasErrored,
    responsesAddIsLoading: state.employee.responses.responsesAddIsLoading,
    responsesDelete: state.employee.responses.responsesDelete,
    responsesDeleteHasErrored: state.employee.responses.responsesDeleteHasErrored,
    responsesDeleteIsLoading: state.employee.responses.responsesDeleteIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDataResponses:       (host)         => dispatch(responsesFetchData(host)),
    fetchDataResponsesAdd:    (host, params) => dispatch(responsesAddFetchData(host, params)),
    fetchDataResponsesDelete: (host, params) => dispatch(responsesDeleteFetchData(host, params))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Responses));
